import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { ComponentName, ModalSize } from 'src/app/Enums/usersFilterEnums';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { InwardService } from 'src/app/shared/services/inward.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import {Location} from '@angular/common';
import { ReceivedByComponent } from '../received-by/received-by.component';
import { UploadChallanComponent } from '../upload-challan/upload-challan.component';
import { DeclinePopupComponent } from './decline-popup/decline-popup.component';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { CollectMaterialComponent } from '../collect-material/collect-material.component';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
import * as XLSX from 'xlsx';
import * as mammoth from 'mammoth';

@Component({
  selector: 'app-view-inward',
  templateUrl: './view-inward.component.html',
  styleUrls: ['./view-inward.component.less']
})
export class ViewInwardComponent implements OnInit {
  modalRef: BsModalRef;
  viewData : any;
  searchText : string = "";
  regId: number;
  regType: string;
  request: any;
  selectedRequest : any;
  showLoading: boolean = true;
  name: string = '';
  attachedFiles: { name: string, type: string, data: string | ArrayBuffer, requestType: string, fileId?: number }[] = [];
  InwardStatus = InwardStatus;
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  id: number;
  
  constructor(
    private modalService: BsModalService,
    private _dataContextService: DataContextService,
    private toast: ToastrService,
    private loaderService: LoaderService,
    private inwardService: InwardService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private trackeromnitureservice:TrackerOmnitureService
  ){
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {

    this.inwardService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.GetById(this.id);
    });

    this.inwardService.deleteReg
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.DeleteAlert(this.regId,this.regType,this.request);
    });

    //Fetching ID of the clicked registration
    this.id = this.route.snapshot.params['id'];

    this.GetById(this.id);

    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('view-inward',username);
    this.trackeromnitureservice.trackPage("pageView");
  }

  GetById(id){
    this._dataContextService.get<any>(this.service_URL.InwardDetails.ViewRequest + '/' + id)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      this.loaderService.show();
      this.inwardService.refreshwithFilters.next();
      // console.log(res);
      this.viewData = res;
      this.attachedFiles=this.viewData.attachedFiles;
      this.selectedRequest = res;
      this.showLoading = false;
    }
    )
  }

  editReg(){
    this.router.navigate(['Inward/EditInwardReq',this.id]);
  }

  deleteReg(requestId: number,returnType: string, request: any) {
    // console.log(requestId)
    // console.log(returnType)

    this.regId = requestId;
    this.regType = returnType;
    this.request = request;
    // this.officeID = selectedOfficeID;
    // this.selectedOffice=office;
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
   
// const modalsmWidth = ModalSize.Small;
    this.modalRef.setClass(ModalSize.Small);
    this.modalRef.content.title = 'Delete Registration';
    this.modalRef.content.description = 'Are you sure you want to delete <b>' + returnType + ' registration </b>?';
    this.modalRef.content.buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'Delete',
        component: ComponentName.Inward
    }
}

  CheckMaterials(){
    let params = {
      statusId : InwardStatus.Checked,
      requestId : this.viewData.requestId,
      updatedBy : localStorage.getItem('email')
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = null;
    statusChangeAudit.newValue = "Check Materials"

    auditData.push(statusChangeAudit);

    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        this.toast.success("Materials Successfully Checked");
        this.GetById(this.id);
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (err) => {
      console.log(err);
    },
    () => {
      //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.viewData.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

      this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        // console.log(res);
      },
      (err) => {
        console.log(err);
      },
      () => {
        window.location.reload();
      })
    })
  }

  CollectMaterials(selectedRequest:any){
    this.modalRef = this.modalService.show(CollectMaterialComponent,{
      initialState : {
          selectedRequest : selectedRequest
      }
    })
    this.modalRef.setClass(ModalSize.Large);
    this.modalRef.content.event.subscribe(res => {
      console.log(res);
    });
  }


  DeclineRequest(selectedRequest : any){
    this.modalRef = this.modalService.show(DeclinePopupComponent,{
      initialState : {
        selectedRequest : selectedRequest
      }
    })
    this.modalRef.setClass(ModalSize.Large);
    // let params = {
    //   statusId : InwardStatus.Declined,
    //   requestId : this.viewData.requestId
    // }

    // this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    // .pipe(takeUntil(this.unsubscribe$))
    // .subscribe((res) => {
    //   if(res == 1){
    //     this.toast.success("Materials Successfully Checked");
    //     this.GetById(this.id);
    //     window.location.reload();
    //   }
    //   else{
    //     this.toast.error("Something went wrong");
    //   }
    // })
  }

  UploadChallan(selectedRequest : any){

    this.modalRef = this.modalService.show(UploadChallanComponent,{
      initialState : {
        selectedRequest : selectedRequest
      }
    })
    this.modalRef.setClass(ModalSize.Large);

  }

  DeleteAlert(selectedReqID: number, office:any, request: any) {
    if(request.isActive == false){
        this.toast.error("Office was already deleted");
        return ;
    }
    let url = this.service_URL.InwardDetails.DeleteRequest + '/' + selectedReqID;       
    // let data = {
    //   id: selectedOfficeID
    // };
        this._dataContextService.postDatawithValuesForDel<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
            // console.log(res);
            if (res=="3") {                
                //ToastrComponent.success("Successfully deleted!");                
                this.toast.error("This office refered in user");
                
            }
            else if(res=="1"){
                this.toast.error("Request was deleted");
                //this.isPaginationChange = false;
                this.location.back();
            }
            else{
                this.toast.error("Some thing went on wrong..")
            }
            
        })
    }


    ReceivedBy(selectedRequest : any){
      // this.modalRef = this.modalService.show(ReceivedByComponent,{
      //   initialState : {
      //     selectedRequest : selectedRequest
      //   }
      // })
      // this.modalRef.setClass(ModalSize.Large);
      // this.modalRef.content.event.subscribe(res => {
      //   // console.log(res);
      // });
      this.Submit();
    }

    Submit(){

      let PrepareObj = {
        RequestId: this.selectedRequest.requestId,
        DCNumber : this.selectedRequest.dcNumber,
        RegistrationDateTime : this.selectedRequest.registrationDateTime,
        ReturnDateTime : this.selectedRequest.returnDateTime,
        Remarks : this.selectedRequest.remarks,
        // BroughtFromId : this.selectedOption === undefined ? 0 : this.selectedOption.broughtFromId,
        BroughtFromId : parseInt(this.selectedRequest.broughtFrom),
        ReceivedById : parseInt(this.selectedRequest.receivedBy),
        // BroughtFromName : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
        // BroughtFrom : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
        BroughtFromName : this.selectedRequest.broughtFromName,
        BroughtFrom : this.selectedRequest.broughtFromName,
        ReceivedBy : this.name.toUpperCase(),
        ReceivedByName : this.name.toUpperCase(),
        ReceivedOn : new Date().toISOString(),
        RegistrationType : this.selectedRequest.registrationType,
        RecipientName : this.selectedRequest.recipientName,
        RecipientEmailId : this.selectedRequest.recipientEmailId,
        IsActive : this.selectedRequest.isActive,
        StatusId : this.selectedRequest.statusId,
        CreatedBy: this.selectedRequest.createdBy,
        cityId: this.selectedRequest.cityId === (0 || undefined)? null : this.selectedRequest.cityId,
        cityName: this.selectedRequest.cityName,
        officeId: this.selectedRequest.officeId === (0 || undefined)? null : this.selectedRequest.officeId,
        CollectedBy: this.selectedRequest.collectedBy,
        CollectedByName: this.selectedRequest.collectedByName,
        officeName: this.selectedRequest.officeName,
        UpdatedBy: localStorage.getItem('email'),
        materialList : this.selectedRequest.materialList,
        attachedFiles:[]
      }
  
      // console.log(PrepareObj);
      
      // let params = {
      //     receivedById: this.selectedRequest.receivedById,
      //     receivedByName: this.name.toUpperCase(),
      //     updatedBy: localStorage.getItem('email')
      // };
  
      this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateInwardRequest, PrepareObj)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if(res == 1){
          this.UpdateStatus();
          //this.toast.success("Updated Received By");
        }
        else{
          this.toast.error("Something went wrong");
        }
      },
      (error)=>{
        this.toast.error("Received By cannot be updated");
      },
      () => {
        this.toast.success("Status Changed to Recieved");
        window.location.reload();
      })       
  }

  UpdateStatus(){
    let params = {
      statusId : InwardStatus.Received,
      requestId : this.selectedRequest.requestId,
      updatedBy: localStorage.getItem('email'),
      CollectedBy: this.selectedRequest.collectedBy,
      CollectedByName: this.selectedRequest.collectedByName
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = "Challan Uploaded";
    statusChangeAudit.newValue = "Received";

    auditData.push(statusChangeAudit);
    
    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        // this.modalService.hide(1);
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (error)=>{
      this.toast.error("Status cannot be updated");
    },
    () => {
      //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.selectedRequest.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };
               
        this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          // console.log(res);
        },
        (err) => {
          console.log(err);
        },
        () => {
          //window.location.reload();
        })
    
  })
}
viewFile(index: number) {
  if (this.attachedFiles.length > 0 && index < this.attachedFiles.length) {
    const file = this.attachedFiles[index];
    const fileName: string = file.name;
    const fileId = file.fileId;
    const extension = fileName.split('.').pop()?.toLowerCase();

    //console.log(`Viewing file: ${fileName}, reqId: ${this.requestId}, fileId: ${fileId}`);
    //this._dataContextService.get<any>(`${this.service_URL.InwardDetails.Download}?reqId=${this.id}&fileId=${fileId}`)
    this._dataContextService.get<any>(`${this.service_URL.InwardDetails.Download}?reqId=${this.id}&fileId=${fileId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        console.log("download file result: " + res);
        const base64 = res.fileBase64;
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob: Blob;
        let mimeType: string;
        
        switch (extension) {
          case 'pdf':
            mimeType = 'application/pdf';
            break;
          case 'doc':
          case 'docx':
            mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            break;
          case 'xls':
          case 'xlsx':
            mimeType = 'application/vnd.ms-excel';
            break;
          case 'jpg':
          case 'jpeg':
            mimeType = 'image/jpeg';
            break;
          case 'png':
            mimeType = 'image/png';
            break;
          default:
            mimeType = 'application/octet-stream';
        }

        blob = new Blob([byteArray], { type: mimeType });
        const blobURL = URL.createObjectURL(blob);
        const fileWindow = window.open("");
        if (fileWindow) {
          if (mimeType.startsWith('image/')) {
            fileWindow.document.write(`<img src='${blobURL}' width='100%' height='100%' />`);
          } else if (mimeType === 'application/pdf') {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          } else if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            mammoth.convertToHtml({ arrayBuffer: byteArray.buffer })
              .then((result) => {
                fileWindow.document.write(result.value);
              })
              .catch((error) => {
                console.log(error);
                this.toast.error("File could not be rendered");
              });
          } else if (mimeType === 'application/vnd.ms-excel') {
            const workbook = XLSX.read(byteArray, { type: 'array' });
            const html = XLSX.utils.sheet_to_html(workbook.Sheets[workbook.SheetNames[0]]);
            fileWindow.document.write(html);
          } else {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          }
        }
      },
      (error) => {
        console.log(error);
        this.toast.error("File could not be downloaded");
      });
  } else {
    console.log("Invalid file index or no attached files.");
  }
}
downloadFile(index:number){

  if(this.attachedFiles.length > 0){  
    
 // this.attachedFiles.forEach(file => {

  var base64: string = "";

  var fileName: string = "";
  
  var extension: string = "";
  const file = this.attachedFiles[index];
 
  fileName = file.name;
  var ext = fileName.split(".");
  extension = ext[1];
  var fileId = file.fileId;
  console.log(`Downloading file: ${fileName}, reqId: ${this.id}, fileId: ${fileId}`);
  this._dataContextService.get<any>(`${this.service_URL.InwardDetails.Download}?reqId=${this.id}&fileId=${fileId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
          console.log("download file result: " +res);
          base64 = res.fileBase64;
          console.log("Download File base64:" + base64);

      },
      (error) => {
          console.log(error);
          this.toast.error("File could not be downloaded");
      },
      () => {
          var a = document.createElement('a');
          console.log("extension" + extension);
          if(extension === 'pdf'){         
              a.href = "data:application/pdf;base64," + base64;
              console.log("Material document" +  a.href );
          }else if (extension === 'doc' || extension === 'docx') {
            a.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + base64;
            console.log("Material document" + a.href);
          } else if (extension === 'xls' || extension === 'xlsx') {
            a.href = "data:application/vnd.ms-excel;base64," + base64;
            console.log("Material document" + a.href);
          } 
          else{
              a.href = "data:image/" + extension + ";base64," + base64;
              console.log("Material document" +  a.href );
          }
          console.log("a.dwonload" + a.download);
          a.download = fileName;
          a.click();

          this.toast.success("File downloaded");
      });
    //});
    }
  }
    goBack() : void{
      this.location.back();
    }
}
